var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-top-bar-mobile",attrs:{"id":"site-top-bar-mobile"}},[_c('div',{staticClass:"wrap"})])
}]

export { render, staticRenderFns }